var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.puzzle !== null)?_c('canvas',{ref:"canvas",staticClass:"canvas",style:({
            cursor: _vm.cursor,
        })}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }